import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import classNames from 'classnames';

const menu = [
  {
    name: 'Bactereality',
    url: 'bactereality',
  },
  {
    name: 'Lost Moments',
    url: 'lost-moments',
  },
  {
    name: 'Works in Progress',
      url: 'in-progress',
  },
  {
    name: 'Forced Coincidence',
    url: 'forced-coincidence',
  },
  {
    name: 'Micropaintings',
    url: 'micropaintings',
  },
  {
    name: 'Inner Values in Outer Space',
    url: 'ivios',
  },
  {
    name: 'Practice',
    url: 'practice',
  },
];

const renderItems = (callback) => {
  return menu.map((item) => {
    const href = `/works/${item.url}`;

    return (
      <li className="menu__item" key={item.url}>
        <NavLink
          onClick={callback}
          className="menu__link"
          activeClassName="is-active"
          to={href}
        >
          { item.name }
        </NavLink>
      </li>
    );
  })
}

const renderIntro = (intro) => {
  if (!intro) return;

  return (
    <ul className="menu__list">
      <li className="menu__item">
        <Link to="/" className="menu__link">Wolfgang Ganter</Link>
      </li>
      <li className="menu__item">
        <Link to="/about" className="menu__link">CV</Link>
      </li>
      <li className="menu__item">
        <Link to="/contact" className="menu__link">Contact</Link>
      </li>
      <li className="menu__item menu__item--separator"></li>
    </ul>
  )
}

const Menu = ({ intro, modifier, handleOnClick }) => (
  <nav className={classNames("menu", {[`menu--${modifier}`]: modifier})}>
    { renderIntro(intro) }
    <ul className="menu__list">
      { renderItems(handleOnClick) }
      <li className="menu__item">
        <Link to="/videos" className="menu__link">Videos</Link>
      </li>
    </ul>
  </nav>
);

export default Menu;



// WEBPACK FOOTER //
// ./src/components/menu/index.js